<template>
    <router-view />
</template>

<script>
    export default {
        name: "StudentDataLayout"
    }
</script>

<style scoped>

</style>